import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { UserServiceProvider } from '@services/user/user.service';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';

@Injectable()
export class StripeServiceProvider {
	stripePK: string;
	stripe_token: string;
	plan: string;

	constructor(
		private messageService: MessageService,
		private userService: UserServiceProvider
	) {}

	showValidationMessage(cardDetailsForm): void {
		if (cardDetailsForm.get('cardNumber').invalid) {
			this.messageService.showToaster('e_0', 'subscription');
		} else if (
			cardDetailsForm.get('cardExpiryMonth').invalid ||
			cardDetailsForm.get('cardExpiryYear').invalid
		) {
			this.messageService.showToaster('e_2', 'subscription');
		} else if (cardDetailsForm.get('cardCvc').invalid) {
			this.messageService.showToaster('e_1', 'subscription');
		}
	}

	createStripeToken(data, cardDetailsForm, plan: string) {
		if (data && data.message) {
			this.stripePK = data.message;
			(<any>window).Stripe.setPublishableKey(this.stripePK);
		}

		const ccNum = cardDetailsForm.get('cardNumber').value;
		const expMonth = cardDetailsForm.get('cardExpiryMonth').value;
		const expYear = cardDetailsForm.get('cardExpiryYear').value;
		const cvcNum = cardDetailsForm.get('cardCvc').value;

		if (
			this.isStripeCardValid({
				ccNum,
				expMonth,
				expYear,
				cvcNum
			})
		) {
			this.plan = plan;

			return Observable.create(obs =>
				(<any>window).Stripe.card.createToken(
					{
						number: ccNum,
						cvc: cvcNum,
						exp_month: expMonth,
						exp_year: expYear
					},
					(status: number, response: any) =>
						this.stripeResponseHandler(status, response, obs)
				)
			);
		}
		return false;
	}

	createWebStripeToken(data, cardDetailsData, plan: string) {
		if (data && data.message) {
			this.stripePK = data.message;
			(<any>window).Stripe.setPublishableKey(this.stripePK);
		}

		const { ccNum, cvcNum, expMonth, expYear } = cardDetailsData;

		if (this.isStripeCardValid({ ccNum, expMonth, expYear, cvcNum })) {
			this.plan = plan;

			return Observable.create(obs =>
				(<any>window).Stripe.card.createToken(
					{
						number: ccNum,
						cvc: cvcNum,
						exp_month: expMonth,
						exp_year: expYear
					},
					(status: number, response: any) =>
						this.stripeResponseHandler(status, response, obs)
				)
			);
		}
		return false;
	}

	isStripeCardValid(data): boolean {
		const { ccNum, expMonth, expYear, cvcNum } = data;

		if (!(<any>window).Stripe.card.validateCardNumber(ccNum)) {
			this.messageService.showToaster('e_0', 'subscription');
			return false;
		}

		if (!(<any>window).Stripe.card.validateExpiry(expMonth, expYear)) {
			this.messageService.showToaster('e_2', 'subscription');
			return false;
		}

		if (!(<any>window).Stripe.card.validateCVC(cvcNum)) {
			this.messageService.showToaster('e_1', 'subscription');
			return false;
		}

		return true;
	}

	setSubscriptionName(subscription: string): string {
		let subscriptionTmp = subscription;
		const user = this.userService.userData;
		const hasReferralDiscount =
			user.promocodeEnabled &&
			user.subscriptionPrice.discount &&
			user.subscriptionPrice.discount.causedByReferral;
		if (user.championForever) {
			subscriptionTmp += '_DISCOUNT_50';

			/* 25% discount have users in first 15 days after registration
         IF they don't use any promo code except referral promo code
        */
		} else if (
			user.promotionActive &&
			(!user.promocodeEnabled || hasReferralDiscount)
		) {
			subscriptionTmp += '_DISCOUNT_25';
		}

		return subscriptionTmp;
	}

	private stripeResponseHandler = (
		status: number,
		response: any,
		observer: Observer<any>
	) => {
		if (response.error) {
			this.messageService.showToaster('e_2', 'general', response.error.message);
			return observer.error(response.error);
		}
		const stripe_token = response.id;
		const plan = this.setSubscriptionName(this.plan);
		return observer.next({ stripe_token, plan });
	};
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/subscription/stripe-service.ts